<template>
  <div class="user-information clearfix">
    <a :href="$link" class="back-home">Tilbage</a>
    <div v-if="title" class="main-title">
      <h2>{{ title }}</h2>
      <div class="account_number">
        <br />
        <span><strong>Kontonummer:</strong> {{ accountNumbre }}</span>
      </div>
    </div>

    <form v-on:submit.prevent="updateUser">
      <div class="clearfix form">
        <div :class="{error: validation.firstName}">
          <input-type v-bind:value="user.firstName" v-on:input="user.firstName = $event" :validation="validation.firstName" :readonly="isReadOnly('firstName')" type="text" label="Fornavn" placeholder="Fornavn" autocomplete="given-name"></input-type>
        </div>
        <div :class="{error: validation.lastName}">
          <input-type v-bind:value="user.lastName" v-on:input="user.lastName = $event" :validation="validation.lastName" :readonly="isReadOnly('lastName')" type="text" label="Efternavn" placeholder="Efternavn" autocomplete="family-name"></input-type>
        </div>
        <div class="half">
          <div class="one-quarter">
            <input-select v-bind:value="user.gender" v-on:input="user.gender = $event" :readonly="isReadOnly('gender')" label="Køn"></input-select>
          </div>
          <div class="one-quarter">
            <input-number v-bind:value="user.postcode" v-on:input="user.postcode = $event" :readonly="isReadOnly('postcode')" label="Postnummer" type="number" placeholder="Postnummer" autocomplete="postal-code"></input-number>
          </div>
        </div>
        <div :class="{error: validation.email}" class="email-input">
          <input-type v-bind:value="user.email" v-on:input="user.email = $event" :validation="validation.email" :readonly="isReadOnly('email')" type="text" label="E-mail" placeholder="E-mail" autocomplete="email"></input-type>
        </div>
        <div class="phone-number" :class="{error: validation.phoneNumber || validation.countryCode}">
          <div>
            <input-type v-bind:value="countryCode" v-on:input="countryCode = $event" :validation="validation.countryCode" :readonly="isReadOnly('phone')" type="text" label="Landekode" placeholder="Landekode" class="tel-country-code" autocomplete="tel-country-code"></input-type>
            <input-type v-bind:value="phoneNumber" v-on:input="phoneNumber = $event" :validation="validation.phoneNumber" :readonly="isReadOnly('phone')" type="tel" label="Telefon" placeholder="Telefon" class="tel-national" autocomplete="tel-national"></input-type>
          </div>
          <!-- user.phone -->
        </div>
        <div :class="{error: validation.birthDate}">
          <input-date-picker v-bind:value="user.birthDate" v-on:input="user.birthDate = $event" :readonly="isReadOnly('birthDate')" :validation="validation.birthDate" label="Fødselsdato (DD/MM/YYYY)"></input-date-picker>
        </div>
        <div v-if="termsAccept" class="checkbox-field" :class="{error: validation.termsAccept}">
          <input-checkbox v-bind:value="user.termsAccept" v-on:input="user.termsAccept = $event" :validation="validation.termsAccept" label="Acceptér betingelser" id="term-condition" :dataInput="'term-condition-' + Math.floor(Math.random() * 100)"></input-checkbox>
        </div>
        <!-- <div v-if="signupFlow && $texts.privacyPolicy" class="checkbox-field" :class="{error: validation.privacyPolicy}">
          <input-checkbox v-bind:value="privacyPolicy" v-on:input="privacyPolicy = $event" :validation="validation.privacyPolicy" label="" id="privacy-policy" :dataInput="'privacy-policy-' + Math.floor(Math.random() * 100)"></input-checkbox>
        </div> -->
        <div class="checkbox-field" :class="{error: validation.emailMarketing}">
          <input-checkbox v-bind:value="user.emailMarketing" v-on:input="user.emailMarketing = $event" :validation="validation.emailMarketing" :readonly="isReadOnly('emailMarketing')" label="Acceptér markedsføring" id="email-marketing" :dataInput="'email-marketing-' + Math.floor(Math.random() * 100)"></input-checkbox>
        </div>
        <!-- <div v-if="signupFlow && $texts.extraTerms" class="checkbox-field" :class="{error: validation.extraTerms}">
          <input-checkbox v-bind:value="extraTerms" v-on:input="extraTerms = $event" :validation="validation.extraTerms" label="" id="extra-terms" :dataInput="'extra-terms-' + Math.floor(Math.random() * 100)"></input-checkbox>
        </div> -->
      </div>
      <div class="btn-box">
        <input v-if="!isFormReadOnly" type="submit" class="update-btn" value="Opdater" />
        <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        <span v-show="loading == true" class="loading"></span>
      </div>
    </form>
    <delete-user v-if="$settings.enableUserDelete && !signupFlow" :userInfo="this.user"></delete-user>
  </div>
</template>

<script>
import Validator from 'Modules/Validator'
import User from 'cashback-api-js/Resources/User'
import InputType from '../Inputs/InputType'
import InputSelect from '../Inputs/Select'
import InputNumber from '../Inputs/Number'
import InputDatePicker from '../Inputs/DatePicker'
import InputPassword from '../Inputs/Password'
import InputCheckbox from '../Inputs/Checkbox'

import DeleteUser from 'Components/Partials/DeleteUser'

export default {
  name: 'User',

  props: {
    title: {
      type: String,
      default: 'Mine oplysninger',
    },
    signupFlow: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    'input-type': InputType,
    'input-select': InputSelect,
    'input-number': InputNumber,
    'input-date-picker': InputDatePicker,
    'input-password': InputPassword,
    'input-checkbox': InputCheckbox,

    'delete-user': DeleteUser,
  },

  data() {
    return {
      user: new User(),
      countryCode: '+45',
      phoneNumber: '',
      successMessage: null,
      errorMessage: null,
      loading: false,
      validation: {},
      readOnly: {},
      privacyPolicy: null,
      extraTerms: null,
      termsAccept: null,
      accountNumbre: '',
    }
  },

  mounted() {
    this.getUser()
  },

  methods: {
    isReadOnly(field) {
      return field in this.$readOnly && this.$readOnly[field]
    },

    getUser() {
      this.$cashback
        .user()
        .then((user) => {
          this.user = user
          this.accountNumbre = user.data.identifiers.account_number
          this.$emit('loaded')
          if (this.signupFlow && this.user.termsAccept == false) this.termsAccept = true
          if (this.user.phone) {
            this.countryCode = this.user.phone.substring(0, 3)
            this.phoneNumber = this.user.phone.substring(3)
          }
        })
        .catch((error) => {})
    },

    updateUser() {
      this.loading = true
      this.validation = {}

      // Validate First name
      if (this.user.firstName.length === 0) {
        this.validation.firstName = 'Indtast venligst dit fornavn'
      }

      // Validate Last name
      if (this.user.lastName.length === 0) {
        this.validation.lastName = 'Indtast venligst dit efternavn'
      }

      // Validate Email
      this.user.email = this.user.email.toLowerCase()
      let emailValid = Validator.email(this.user.email)
      if (emailValid !== true) {
        this.validation.email = emailValid
      }

      this.user.phone = ''
      // Validate country code
      if (this.phoneNumber) {
        if (this.countryCode.substring(0, 1) !== '+') {
          this.countryCode = '+' + this.countryCode
        }
        let countryCodeValid = Validator.countryCode(this.countryCode)
        if (countryCodeValid !== true) {
          this.validation.countryCode = countryCodeValid
        }

        // Validate Phone
        let phoneNumberValid = Validator.phone(this.phoneNumber)
        if (phoneNumberValid !== true) {
          this.validation.phoneNumber = phoneNumberValid
        }
        this.user.phone = this.countryCode + this.phoneNumber
      }

      // Date picker doesn't accept null
      if (this.user.birthDate == null) {
        this.user.birthDate = ''
      }
      // Validate Birth date format
      if (this.user.birthDate.length > 0) {
        let birthDateValid = Validator.birthDate(this.user.birthDate)
        if (birthDateValid !== true) {
          this.validation.birthDate = birthDateValid
        }
      }

      // validation terms and condition
      if (this.signupFlow && this.user.termsAccept == false) {
        this.validation.termsAccept = 'Vilkår og betingelser skal godkendes før registreringen kan færdiggøres.'
      }

      if (this.signupFlow && this.$texts.privacyPolicy && !this.privacyPolicy) {
        this.validation.privacyPolicy = 'Persondatapolitik skal godkendes før registreringen kan færdiggøres.'
      }

      if (this.signupFlow && !this.user.emailMarketing) {
        this.validation.emailMarketing = 'Email markedsføring skal godkendes før registreringen kan færdiggøres.'
      }

      if (this.signupFlow && this.$texts.extraTerms && !this.extraTerms) {
        this.validation.extraTerms = 'Vilkår, betingelser og markedsføring skal godkendes før registreringen kan færdiggøres.'
      }

      if (Object.entries(this.validation).length !== 0) {
        this.loading = false
        return
      }

      // Set read only fields to null
      let userToUpdate = new User()
      // Only update these fields
      userToUpdate.firstName = this.user.firstName
      userToUpdate.lastName = this.user.lastName
      userToUpdate.gender = this.user.gender
      userToUpdate.postcode = this.user.postcode
      userToUpdate.email = this.user.email
      userToUpdate.phone = this.user.phone
      userToUpdate.birthDate = this.user.birthDate
      userToUpdate.termsAccept = this.user.termsAccept
      userToUpdate.privacyPolicy = this.user.privacyPolicy
      userToUpdate.emailMarketing = this.user.emailMarketing
      userToUpdate.extraTerms = this.user.extraTerms

      let key = ''

      for (key in this.$readOnly) {
        if (this.$readOnly[key] == true) {
          userToUpdate[key] = null
        }
      }

      this.$cashback
        .userUpdate(userToUpdate)
        .then((update) => {
          this.loading = false
          this.successMessage = 'Din profil er opdateret'
          if ((this.successMessage = 'Din profil er opdateret')) {
            this.$emit('success-update-user')
          }
          setTimeout(() => {
            this.successMessage = null
          }, 2000)
        })
        .catch((error) => {
          this.loading = false
          this.errorMessage = 'Fejl, vær venlig at prøve igen'
          // this.errorMessage = error.message // this actually holds the correct error message but be careful exposing it because it could be used to check which emails and phonenumbers are already in the system
          setTimeout(() => {
            this.errorMessage = null
          }, 6000)
        })
    },
  },

  computed: {
    isFormReadOnly() {
      let readOnly = this.$readOnly

      if (Object.keys(readOnly).length === 0) {
        return false
      }

      return readOnly.firstName && readOnly.lastName && readOnly.gender && readOnly.email && readOnly.phone && readOnly.birthDate && readOnly.pushNotifications && readOnly.emailMarketing && readOnly.postcode
    },
  },
}
</script>
